<template>
  <div>
    <div class="headline5 mb-4">
      {{ $t(`modals.addGlobalMspPolicy.policies.generalInfo.title`) }}
    </div>
    <v-card class="card-wrapper">
      <v-card-text class="pa-6">
        <v-form ref="form" v-model="formValid">
          <v-text-field
            class="mt-4 days-input"
            :label="$t('modals.addGlobalMspPolicy.policies.generalInfo.policyName')"
            :aria-label="$t('modals.addGlobalMspPolicy.policies.generalInfo.policyName')"
            :hint="$t('modals.addGlobalMspPolicy.policies.generalInfo.policyNameHint')"
            v-model="localValue.name"
            persistent-hint
            :disabled="disabled"
            :rules="[required()]"
          ></v-text-field>

          <v-text-field
            class="mt-4 mb-2 days-input"
            :label="$t('modals.addGlobalMspPolicy.policies.generalInfo.description')"
            :aria-label="$t('modals.addGlobalMspPolicy.policies.generalInfo.description')"
            v-model="localValue.description"
            :disabled="disabled"
          ></v-text-field>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType, ref, watch } from "vue";
import cloneDeep from "lodash/cloneDeep";
import type { GlobalPolicyConfig } from "@/_store/msp/global-policies/msp-global-policies.module.ts";
import { required } from "@/_helpers/validators.ts";

export default defineComponent({
  props: {
    data: {
      type: Object as PropType<GlobalPolicyConfig>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:data"],
  setup(props, { emit }) {
    const localValue = ref(cloneDeep(props.data));
    const form = ref();
    const formValid = ref(true);
    watch(
      localValue,
      (newVal) => {
        emit("update:data", {
          ...props.data,
          ...newVal,
        });
      },
      { immediate: true, deep: true }
    );

    const validate = async () => {
      const { valid } = await form.value.validate();
      return valid;
    };

    return {
      required,
      form,
      validate,
      formValid,
      localValue,
    };
  },
});
</script>

<style scoped lang="scss"></style>
